import MenuSectionImplementation from '../implementation/sections/MenuSection';
import { ComponentProps } from '@components/strapi/DynamicZoneComponent';
import {
  StrapiMenuSectionDTO,
  MenuSectionDTO,
} from '@lib/strapi/dtos/components/sections/menuSection.dto';

const MenuSection = (props: ComponentProps<MenuSectionDTO>) => {
  return <MenuSectionImplementation {...props}></MenuSectionImplementation>;
};

export default MenuSection;
